export default __webpack_public_path__ + "static/media/reading.fe404403.svg";